let controller = new AbortController();

export function getContextSignal(): AbortSignal {
    return controller.signal;
}

/** Abort every in-flight request tied to the current context and start a new one. */
export function resetRequestContext(): void {
    controller.abort();
    controller = new AbortController();
}
